import React, { useState } from 'react';

// Extraído del modal inline que vivía en App.js (mismo JSX/clases, cero
// cambio visual) para poder reusarlo desde otros flujos que también dan de
// alta un paciente nuevo pero necesitan hacer algo distinto al confirmar
// (ver ItemEventoPendiente.jsx, que en vez de createPatient llama a
// link-new-patient/ para crear y vincular el turno en un solo paso atómico).
function ModalNuevoPaciente({
  nombreInicial = '', apellidoInicial = '', guardando = false,
  onConfirmar, onCerrar,
  titulo = 'Nuevo paciente',
  textoAlerta = 'Podés completar el resto de los datos desde la ficha del paciente.',
  textoBoton = 'Crear paciente', textoBotonGuardando = 'Creando...',
  errorExterno = null,
}) {
  const [nombre, setNombre] = useState(nombreInicial);
  const [apellido, setApellido] = useState(apellidoInicial);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!nombre.trim() && !apellido.trim()) return;
    onConfirmar(nombre, apellido);
  };

  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && onCerrar()}>
      <div className="modal-card modal-card-sm">
        <div className="modal-header">
          <h3>{titulo}</h3>
          <button className="modal-btn-cerrar" onClick={onCerrar}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="modal-fila-2">
              <div className="modal-campo">
                <label className="modal-label">Nombre</label>
                <input
                  className="modal-input"
                  value={nombre}
                  onChange={e => setNombre(e.target.value)}
                  placeholder="Nombre"
                  autoFocus
                />
              </div>
              <div className="modal-campo">
                <label className="modal-label">Apellido</label>
                <input
                  className="modal-input"
                  value={apellido}
                  onChange={e => setApellido(e.target.value)}
                  placeholder="Apellido"
                />
              </div>
            </div>
            {textoAlerta && (
              <p className="confirm-alerta" style={{ marginTop: 8 }}>{textoAlerta}</p>
            )}
            {errorExterno && (
              <p className="confirm-alerta" style={{ marginTop: 8 }}>{errorExterno}</p>
            )}
          </div>
          <div className="modal-acciones" style={{ padding: '12px 24px 20px' }}>
            <button type="button" className="modal-btn-cancelar" onClick={onCerrar}>Cancelar</button>
            <button type="submit" className="modal-btn-guardar" disabled={guardando || (!nombre.trim() && !apellido.trim())}>
              {guardando ? textoBotonGuardando : textoBoton}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ModalNuevoPaciente;
